module.exports = __webpack_public_path__ + "static/img/company.1354e7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/company.png
// module id = JWP8
// module chunks = 2